"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shipmentStatusMap = void 0;
const ShipmentStatus_1 = require("./ShipmentStatus");
exports.shipmentStatusMap = {
    [ShipmentStatus_1.ShipmentStatus.DRAFT]: 100,
    [ShipmentStatus_1.ShipmentStatus.CREATED]: 200,
    [ShipmentStatus_1.ShipmentStatus.SCHEDULED]: 300,
    [ShipmentStatus_1.ShipmentStatus.SUBMITTED]: 400,
    [ShipmentStatus_1.ShipmentStatus.PROCESSING]: 500,
    [ShipmentStatus_1.ShipmentStatus.READY_TO_SHIP]: 600,
    [ShipmentStatus_1.ShipmentStatus.SHIPPED]: 700,
    [ShipmentStatus_1.ShipmentStatus.DELIVERED]: 800,
    [ShipmentStatus_1.ShipmentStatus.ARRIVED]: 900,
    [ShipmentStatus_1.ShipmentStatus.RECEIVING]: 1000,
    [ShipmentStatus_1.ShipmentStatus.COMPLETED]: 1100,
    [ShipmentStatus_1.ShipmentStatus.CANCELLED]: 1200,
    [ShipmentStatus_1.ShipmentStatus.ERROR]: -100,
};
//# sourceMappingURL=ShipmentStatusMap.js.map